/**
 * Every AI notice in AVA, in one place (product owner, 2026-10-15; voice showcase
 * src/assets/showcase/ai-chat-client-voice-showcase.html). Screens import these; none writes its own.
 *
 * - CHAT: the line under the AVA Assistant composer, in every state and width.
 * - CONTENT: AI output shown in a panel (AVA Inspect findings).
 * - VOICE: said where an AI voice is heard (Read aloud; OpenAI's speech policy asks for it).
 *
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */
export const AI_DISCLOSURE = Object.freeze({
  CHAT: 'AVA is AI and can make mistakes. Check important info.',
  CONTENT: 'AI-generated. It can make mistakes, so check it before you rely on it.',
  VOICE: 'AI voice',
});
